import React from 'react';
import styled from 'styled-components';
import { colors, spaces } from '../../../shared/lib/styles';
import Heading from '../../../shared/components/Heading';
import Paragraph from '../../../shared/components/Paragraph';

interface Props {
    image: React.ReactNode;
    stepNumber: string;
    title: string;
    description: React.ReactNode;
}

const ImageWrapper = styled.div`
    max-width: 318px;
    padding-top: ${spaces.space7}px;
`;

const Description = styled(Paragraph)`
    color: ${colors.typography.root};
`;

function HowItWorksCard({ image, stepNumber, title, description }: Props) {
    return (
        <>
            <ImageWrapper>{image}</ImageWrapper>
            <Heading type="h3" variations={['h4', 'no-margin']}>
                {stepNumber}
            </Heading>
            <Heading type="h4" variations={['h5']}>
                {title}
            </Heading>
            <Description variations={['no-margin']}>{description}</Description>
        </>
    );
}

export default HowItWorksCard;
